// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:15
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class Ellipse_abstract extends BaseObject {
  static $t: string = 'SagaBase.Defines.Ellipse';
  $t: string = 'SagaBase.Defines.Ellipse';

  public static GetMembers(): string[] {
    return ['Id', 'CenterX', 'CenterY', 'SemiMinor', 'RotationAngle', 'SemiMajor', 'CoordEpsgCode'];
  }

  public GetMembers(): string[] {
    return Ellipse_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public Id: Guid = GuidTools.Empty;
  public CenterX: number = 0;
  public CenterY: number = 0;
  public SemiMinor: number = 0;
  public RotationAngle: number = 0;
  public SemiMajor: number = 0;
  public CoordEpsgCode: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
